const
    configurations = {
    //baseUrl: 'http://3.136.92.227:8089/api/v3.0'  /* Deployment Server for Perscitus Developer*/,
    baseUrl: 'https://dev.fabric.carynhealth.com/api/v9.0'  /* Deployment Server for Perscitus Developer*/,
    clientId : '5448',
    chat_Box_Id : 'b605e486-1658-4e35-8239-d9bd3952006e',
    //agentURL : 'http://3.136.92.227:8088/api/v4', // Only for test server
     agentURL : 'https://dev.fabric.carynhealth.com/api/v10',  // Only for UAT/Dev Enviornment
	 transactionURL: "https://dev.fabric.carynhealth.com/api/v6", //url for setup payment and last 4 digit
    //transactionURL:"http://3.136.92.227:8085/api/v6", //for local and test server Transaction URL
    authenticationURL:'https://dev.fabric.carynhealth.com/api/',
    isProd:false
}
   
export default configurations;